// @flow
import React from "react"
import ChangePasswordForm from "./ChangePasswordForm"
import SettingContent from "../../SettingContent"

const ChangePassword = () => (
  <SettingContent title="Reset password">
    <ChangePasswordForm />
  </SettingContent>
)

export default ChangePassword



// WEBPACK FOOTER //
// ./src/pages/Account/Routes/Subpages/ChangePassword/index.js